export const defaultPersonAttributes = [
  {
    id: 'name',
    collection: 'Person',
    data_type: 'str',
    u_key: 'Name',
    is_default: true,
  },
  {
    id: 'first_name',
    collection: 'Person',
    data_type: 'str',
    u_key: 'First Name',
    is_default: true,
  },
  {
    id: 'last_name',
    collection: 'Person',
    data_type: 'str',
    u_key: 'Last Name',
    is_default: true,
  },
  {
    id: 'email',
    collection: 'Person',
    data_type: 'str',
    u_key: 'Email',
    is_default: true,
  },
  {
    id: 'companies',
    collection: 'Person',
    data_type: 'list',
    u_key: 'Companies',
    is_default: true,
  },
  {
    id: 'occupation',
    collection: 'Person',
    data_type: 'str',
    u_key: 'Occupation',
    is_default: true,
  },
  {
    id: 'external_id',
    collection: 'Person',
    data_type: 'str',
    u_key: 'External ID',
    is_default: true,
  },
  {
    id: 'phone',
    collection: 'Person',
    data_type: 'str',
    u_key: 'Phone',
    is_default: true,
  },
  {
    id: 'address',
    collection: 'Person',
    data_type: 'str',
    u_key: 'Address',
    is_default: true,
  },
  {
    id: 'pp_opt_outs.all',
    collection: 'Person',
    data_type: 'bool',
    u_key: 'Opt Out (Unsubscribed)',
    is_default: true,
  },
];
